const buildQuery = (data, encode = false) => {
  if (typeof data === 'string') return data;

  const getKey = key => encode ? encodeURIComponent(key) : key;

  const getValue = value => encode ? encodeURIComponent(value) : value;

  const queryString = Object.keys(data).map(key => `${getKey(key)}=${getValue(data[key])}`).join('&');
  return queryString;
};

export default buildQuery;